import React, { useEffect, useState } from "react";
import { api, IUpsellsPackageListForBooking, UpsellPackage, UpsellPackagedProduct } from "../../../logic/api";
import { PagedDataView } from "../../lists/PagedDataView/PagedDataView";
import UpsellSelectorListItem from "./UpsellSelectorListItem";
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";

const UpsellSelector: React.FunctionComponent<{
  bookingId: number,
  onSelect: (pkg: UpsellPackage, product: UpsellPackagedProduct) => void,
}> = (props) => {
  const useUpsellListV2 = useReleaseManagement(ReleaseFlag.releaseImproveUpsellsPerformance);

  const [packageListFetchParams, setPackageListFetchParams] = useState<IUpsellsPackageListForBooking>({
    bookingId: props.bookingId,
  });

  const listAvailableUpsells = useUpsellListV2 ? api.hooks.upsell.listAvailableForBookingV2 : api.hooks.upsell.listAvailableForBooking;

  useEffect(() => {
    setPackageListFetchParams({ ...packageListFetchParams, bookingId: props.bookingId });
  }, [props.bookingId])

  return <PagedDataView<IUpsellsPackageListForBooking, UpsellPackage>
    apiHook={listAvailableUpsells}
    parameters={packageListFetchParams}
    paged={false}
    renderItem={(item) => {
      return <UpsellSelectorListItem upsellPackage={item} onSelect={(pkg, product) => props.onSelect(pkg, product)}></UpsellSelectorListItem>
    }}>
    <div></div>
  </PagedDataView>;
}

export default UpsellSelector;
